import { createAction } from 'redux-actions';

const actions = {
  /**
   * [상품 문의] 상품 문의 데이터 변경하기
   */
  SET_DATA: 'cs/qna/SET_DATA',
  setData: createAction('cs/qna/SET_DATA'),

  /**
   * [상품 문의 리스트] 상품 문의 리스트 요청하기
   */
  GET_QNA_LIST_REQUEST: 'cs/qna/GET_QNA_LIST_REQUEST',
  GET_QNA_LIST_SUCCESS: 'cs/qna/GET_QNA_LIST_SUCCESS',
  getCsQnaList: createAction('cs/qna/GET_QNA_LIST_REQUEST'),

  /**
   * [상품 문의 리스트] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  GET_QNA_EXCEL_DOWNLOAD_REQUEST: 'cs/qna/GET_QNA_EXCEL_DOWNLOAD_REQUEST',
  getQnaExcelDownload: createAction('cs/qna/GET_QNA_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [상품 문의 상세] 상품 문의 상세 요청하기
   */
  GET_QNA_DETAIL_REQUEST: 'cs/qna/GET_QNA_DETAIL_REQUEST',
  GET_QNA_DETAIL_SUCCESS: 'cs/qna/GET_QNA_DETAIL_SUCCESS',
  getCsQnaDetail: createAction('cs/qna/GET_QNA_DETAIL_REQUEST'),

  /**
   * [상품 문의 상세] 유저의 다른 문의 내역 요청하기
   */
  GET_USERS_OTHER_QNA_LIST_REQUEST: 'cs/qna/GET_USERS_OTHER_QNA_LIST_REQUEST',
  GET_USERS_OTHER_QNA_LIST_SUCCESS: 'cs/qna/GET_USERS_OTHER_QNA_LIST_SUCCESS',
  getCsUsersOtherQnaList: createAction('cs/qna/GET_USERS_OTHER_QNA_LIST_REQUEST'),

  /**
   * [상품 문의 상세] 상품 문의 상태 변경 요청하기
   */
  CHANGE_QNA_STATUS_REQUEST: 'cs/qna/CHANGE_QNA_STATUS_REQUEST',
  changeQnaStatus: createAction('cs/qna/CHANGE_QNA_STATUS_REQUEST'),

  /**
   *  [상품 문의 상세] 상품 문의 비밀글 여부 변경 요청하기
   */
  CHANGE_QNA_SECRET_REQUEST: 'cs/qna/CHANGE_QNA_SECRET_REQUEST',
  changeQnaSecret: createAction('cs/qna/CHANGE_QNA_SECRET_REQUEST'),

  /**
   * [상품 문의 상세] 상품 문의 답변 작성하기
   */
  REPLY_QNA_DETAIL_REQUEST: 'cs/qna/REPLY_QNA_DETAIL_REQUEST',
  REPLY_QNA_DETAIL_SUCCESS: 'cs/qna/REPLY_QNA_DETAIL_SUCCESS',
  replyCsQnaDetail: createAction('cs/qna/REPLY_QNA_DETAIL_REQUEST'),

  /**
   * [상품 문의] 질문 내용 모달 토글
   */
  TOGGLE_MODAL: 'cs/qna/TOGGLE_MODAL',
  toggleModal: createAction('cs/qna/TOGGLE_MODAL'),
};

export default actions;
